<div class="py-10 position-relative">
  <div class="row justify-content-center">
    <div class="col-11 col-md-8">
      <p class="text-center mb-2">
        One last step
      </p>
      <h2 class="text-center mb-8 fw-bold">
        What type of answer
        do you need?
      </h2>
      <button
        type="button"
        (click)="setAnswerType('detailed')"
        class="btn btn-outline border-2 app-btn-black w-100 mb-4"
      >
        Step-by-step
      </button>
      <button
        type="button"
        (click)="setAnswerType('answer')"
        class="btn btn-outline border-2 app-btn-white w-100"
      >
        Only answer
      </button>
    </div>
  </div>
</div>
